const base = 'http://gst-sass.lazhuyun99.cn';
let H5BASE = API_CONFIG.ENV == 1 ? 'https://gst-sass-h5.jingchengxg.com' : 'https://gst-sass-h5.lazhuyun99.cn';
export default {
  env: API_CONFIG.ENV, // 渠道 0 测试 1正式 2本地 3演示
  ver: API_CONFIG.VER, // 版本
  base: API_CONFIG.ENV == 2 ? base : location.origin,
  h5Base: H5BASE,
  htmlUrl: location.origin
};
